export const UploadSource = Object.freeze({
  LOCAL: 'local',
  DROP_AREA: 'drop-area',
  URL_TAB: 'url-tab',
  CAMERA: 'camera',
  EXTERNAL: 'external',
  API: 'js-api',
});
